<template>
  <base-grid
    :class="[
      Classes.STATS,
      'guide-stats game-secondary-button-border-color game-tile-radius tw-overflow-hidden game-tile-border',
    ]"
    :cols="2"
    :x-gap="0"
    :y-gap="0"
  >
    <view-stat
      icon="eye"
      :title="$t('views')"
      :text="guide?.stats?.visits_total?.toLocaleString() || 0"
      :panel-loading="panelLoading"
    />

    <view-stat
      icon="comment"
      :title="$t('sort_comments')"
      :text="guide?.stats?.comments_total?.toLocaleString() || 0"
      :panel-loading="panelLoading"
    />
  </base-grid>
</template>

<script>
import ViewStat from '@components/View/ViewStat.vue'
import Classes from '@shared/js/config/css.js'

export default {
  components: {
    ViewStat,
  },
  props: {
    panelLoading: {
      type: Boolean,
      default: false,
    },
    guide: {
      type: Object,
      default: null,
    },
  },
  setup() {
    return { Classes }
  },
}
</script>
<style>
.guide-stats {
  div.section {
    border-bottom: var(--tile-border-width) solid var(--tile-border-color);
    border-right: var(--tile-border-width) solid var(--tile-border-color);
  }

  div.section:nth-child(2),
  div.section:nth-child(4) {
    border-right: none;
  }

  div.section:nth-child(1),
  div.section:nth-child(2) {
    border-bottom: none;
  }
}
</style>
